module.exports = __webpack_public_path__ + "img/75636.cb18e997.svg";